import {BasicComponentRegistry, ComponentRegistry, VueComponent} from "@zoovu/runner-browser-api";
import {LocaleMessageProvider} from "./adapters/locale-message-provider";

export class ComponentRegistryFactory {
    public static createComponentRegistry(): ComponentRegistry {
        // @ts-ignore
        const requireComponent = require.context(
            "./components",
            false,
            /.*\.vue$/
        );

        const components = [];

        requireComponent.keys().forEach((fileName) => {
            const component = requireComponent(fileName);
            components.push(component.default || component);
        });

        const basicComponentRegistry = new BasicComponentRegistry(components);

        basicComponentRegistry.registerHook((configuration: any, root: VueComponent<any>) => {
            if (configuration && configuration.standardTexts) {
                // @ts-ignore
                const i18n = root.$i18n;

                const localeMessages = new LocaleMessageProvider(configuration.standardTexts, basicComponentRegistry).withInitializedDefaults().getLocaleMessages();

                i18n.setLocaleMessage(localeMessages.locale, localeMessages.messages);
                i18n.locale = localeMessages.locale;
            }
            return {};
        });

        return basicComponentRegistry;
    }
}
